export default __webpack_public_path__ + "static/media/IMG_4049.ec299e03.JPG";